var h = Object.defineProperty;
var l = (n, e, t) => e in n ? h(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var r = (n, e, t) => l(n, typeof e != "symbol" ? e + "" : e, t);
import { TextBlockParser as c } from "./text-block-parser.js";
import { BLOCK_TYPES as i, DEFAULT_ALIGNMENT as u } from "./constants.js";
import "./bundled_deps/.pnpm/@intercom_intercom-sanitizer@3.0.0_@braintree_sanitize-url@7.0.2_isomorphic-dompurify@2.26.0_canvas@3.2.0_/bundled_deps/@intercom/intercom-sanitizer/dist/index.js";
import { getResponsiveClasses as m } from "./utils/tables.js";
import { __exports as p } from "./_virtual/index.js";
class C {
  constructor(e, t) {
    r(this, "schema");
    r(this, "textBlockParser");
    this.documentBuilder = e, this.config = t, this.schema = e.schema, this.textBlockParser = new c(e, t);
  }
  handle(e, t) {
    switch (e.type) {
      case i.ORDERED_NESTED_LIST:
      case i.UNORDERED_NESTED_LIST:
        this.nestedList(e);
        break;
      case i.PARAGRAPH:
      case i.ORDERED_LIST:
      case i.UNORDERED_LIST:
      case i.HEADING:
      case i.SUBHEADING:
      case i.SUBHEADING3:
      case i.SUBHEADING4:
      case i.SMALL:
      case i.CODE:
        this.textBlockParser.handle(e, t);
        break;
      case i.HTML:
        this.html(e);
        break;
      case i.HORIZONTAL_RULE:
        this.horizontalRule(e);
        break;
      case i.IMAGE:
        this.image(e);
        break;
      case i.IMAGE_TEXT:
        this.imageText(e);
        break;
      case i.VIDEO:
        this.video(e);
        break;
      case i.VIDEO_FILE:
        this.videoFile(e);
        break;
      case i.AUDIO_FILE:
        this.audioFile(e);
        break;
      case i.BUTTON:
        this.button(e);
        break;
      case i.MESSENGER_CARD:
        this.messengerCard(e);
        break;
      case i.TABLE:
        this.table(e);
        break;
      case i.IF_ELSE_STATEMENT:
        this.ifElseStatement(e);
        break;
      case i.TWITTER_FOLLOW_BUTTON:
        this.twitterFollowButton(e);
        break;
      case i.FACEBOOK_LIKE_BUTTON:
        this.facebookLikeButton(e);
        break;
      case i.SOCIAL:
        this.social(e);
        break;
      case i.SPACER:
        this.spacer(e);
        break;
      case i.CALLOUT:
        this.callout(e);
        break;
      case i.COLLAPSIBLE_SECTION:
        this.collapsibleSection(e);
        break;
      case i.UNSUPPORTED_ELEMENT:
        this.unsupportedElement(e);
        break;
    }
  }
  table(e) {
    const t = this.schema.nodes.table;
    if (t) {
      let s = {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        responsive: e.responsive || !1,
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        container: e.container || !1,
        sectionType: e.sectionType
      };
      typeof e.stacked == "boolean" && (s.stacked = e.stacked);
      const d = this.getPaddingAttrs(e);
      s = {
        ...s,
        backgroundColor: this.addBackgroundColor(e) ?? "",
        borderRadius: this.addBorderRadius(e) ?? "",
        ...d
      }, this.documentBuilder.openNode(t, s), e.rows.forEach((o) => this.tableRow(o, s)), this.documentBuilder.closeNode();
    }
  }
  tableRow(e, t) {
    const s = this.schema.nodes.tableRow;
    if (s) {
      let d = t.responsive ? { responsiveClasses: m(e.cells.length) } : {};
      d = t.container ? { ...d, container: !0 } : d, this.documentBuilder.openNode(s, {}), e.cells.forEach((o) => this.tableCell(o, d)), this.documentBuilder.closeNode();
    }
  }
  tableCell(e, t) {
    const s = this.schema.nodes.tableCell;
    if (s) {
      if (t.container) {
        const d = this.getPaddingAttrs(e);
        t = {
          ...t,
          ...d
        };
      }
      !t.container && !t.responsive && (t = {
        ...t,
        backgroundColor: this.addBackgroundColor(e) ?? ""
      }), e.displayWidth && (t = {
        ...t,
        colwidth: [e.displayWidth]
      }), this.documentBuilder.openNode(s, t), t.container && e.content.length === 0 && this.schema.nodes.placeholder && this.placeholder(), e.content.forEach((d) => this.handle(d)), this.documentBuilder.closeNode();
    }
  }
  social(e) {
    const t = this.schema.nodes.social;
    t && (this.documentBuilder.openNode(t, {
      alignment: this.alignmentClass(e),
      items: e.items
    }), this.documentBuilder.closeNode());
  }
  spacer(e) {
    const t = this.schema.nodes.spacer;
    t && (this.documentBuilder.openNode(t, {
      height: e.height
    }), this.documentBuilder.closeNode());
  }
  callout(e) {
    const t = this.schema.nodes.callout;
    t && (this.documentBuilder.openNode(t, {
      type: e.type,
      backgroundColor: this.addBackgroundColor(e) ?? "",
      borderColor: this.addBorderColor(e) ?? ""
    }), e.content.forEach((s) => this.handle(s)), this.documentBuilder.closeNode());
  }
  unsupportedElement(e) {
    const t = this.schema.nodes.unsupportedElement;
    t && (this.documentBuilder.openNode(t, {
      type: e.type,
      unsupportedTypeName: e.unsupportedTypeName,
      text: e.text
    }), this.documentBuilder.closeNode());
  }
  placeholder(e = {}) {
    this.documentBuilder.openNode(this.schema.nodes.placeholder, e), this.documentBuilder.closeNode();
  }
  nestedList(e) {
    const t = this.schema.nodes[e.type];
    t && (this.documentBuilder.openNode(t, {}), e.items.forEach((s) => this.nestedListItem(s)), this.documentBuilder.closeNode());
  }
  nestedListItem(e) {
    const t = this.schema.nodes.nestedListItem;
    t && (this.documentBuilder.openNode(t, {}), e.content.forEach((s) => this.handle(s)), this.documentBuilder.closeNode());
  }
  ifElseStatement(e) {
    const t = this.schema.nodes.ifElseStatement;
    t && (this.documentBuilder.openNode(t, {
      predicatesBlocksPairs: e.predicatesBlocksPairs,
      fallbackBlocks: e.fallbackBlocks
    }), this.documentBuilder.closeNode());
  }
  twitterFollowButton(e) {
    const t = this.schema.nodes.twitterFollowButton;
    t && (this.documentBuilder.openNode(t, {
      username: e.username
    }), this.documentBuilder.closeNode());
  }
  facebookLikeButton(e) {
    const t = this.schema.nodes.facebookLikeButton;
    t && (this.documentBuilder.openNode(t, {
      url: e.url
    }), this.documentBuilder.closeNode());
  }
  image(e) {
    var s;
    const t = this.schema.nodes.image;
    if (t) {
      const d = e.url, a = {
        // Use placeholder if URL is invalid, otherwise use the original URL
        src: d && typeof d == "string" && d.trim() !== "" ? d : ((s = this.config.images) == null ? void 0 : s.failedImageUrl) ?? "",
        linkUrl: e.linkUrl,
        text: e.text,
        width: e.width,
        displayWidth: e.displayWidth,
        height: e.height,
        alignment: this.alignmentClass(e)
      };
      this.documentBuilder.openNode(t, a), this.documentBuilder.closeNode();
    }
  }
  imageText(e) {
    const t = this.schema.nodes.imageText;
    t && (this.documentBuilder.openNode(t, {
      imageUrl: e.imageUrl,
      title: "title" in e ? e.title : "",
      text: e.text
    }), this.documentBuilder.closeNode());
  }
  video(e) {
    const t = this.schema.nodes.video;
    if (t) {
      const s = "videoId" in e ? e.videoId : e.id;
      this.documentBuilder.openNode(t, {
        type: e.type,
        provider: e.provider,
        id: s
      }), this.documentBuilder.closeNode();
    }
  }
  videoFile(e) {
    const t = this.schema.nodes.videoFile;
    t && (this.documentBuilder.openNode(t, {
      type: e.type,
      thumbnailUrl: e.thumbnailUrl,
      url: e.url,
      captions: e.captions
    }), this.documentBuilder.closeNode());
  }
  audioFile(e) {
    const t = this.schema.nodes.audioFile;
    t && (this.documentBuilder.openNode(t, {
      type: e.type,
      url: e.url
    }), this.documentBuilder.closeNode());
  }
  button(e) {
    const t = this.schema.nodes.button, s = this.unescapeExpression(e.text);
    if (t) {
      const d = this.getPaddingAttrs(e);
      this.documentBuilder.openNode(t, {
        type: e.type,
        linkUrl: e.linkUrl,
        buttonStyle: e.buttonStyle || "solid",
        alignment: this.alignmentClass(e),
        fontFamily: this.addFontFamily(e) ?? "",
        fontColor: this.addFontColor(e) ?? "",
        backgroundColor: this.addBackgroundColor(e) ?? "",
        ...d,
        borderRadius: this.addBorderRadius(e) ?? "",
        text: s
      }), this.documentBuilder.closeNode();
    }
  }
  unescapeExpression(e) {
    const t = document.createElement("div");
    return t.innerHTML = p.sanitizeHtml(e), t.textContent || "";
  }
  horizontalRule(e) {
    const t = this.schema.nodes.horizontalRule;
    t && (this.documentBuilder.openNode(t, {
      type: e.type,
      text: e == null ? void 0 : e.text,
      width: (e == null ? void 0 : e.width) ?? "",
      borderColor: this.addBorderColor(e) ?? "",
      borderWidth: this.addBorderWidth(e) ?? "",
      borderStyle: this.addBorderStyle(e) ?? ""
    }), this.documentBuilder.closeNode());
  }
  collapsibleSection(e) {
    const t = this.schema.nodes.collapsibleSection;
    t && (this.documentBuilder.openNode(t, {}), this.collapsibleSectionSummary(e), this.collapsibleSectionContent(e), this.documentBuilder.closeNode());
  }
  collapsibleSectionSummary(e) {
    const t = this.schema.nodes.collapsibleSectionSummary;
    t && (this.documentBuilder.openNode(t, {}), this.handle(e.summary), this.documentBuilder.closeNode());
  }
  collapsibleSectionContent(e) {
    const t = this.schema.nodes.collapsibleSectionContent;
    t && (this.documentBuilder.openNode(t, {}), e.content.forEach((s) => this.handle(s)), this.documentBuilder.closeNode());
  }
  html(e) {
    const t = this.schema.nodes.html;
    t && (this.documentBuilder.openNode(t, { content: e.content }), this.documentBuilder.closeNode());
  }
  messengerCard(e) {
    const t = this.schema.nodes.messengerCard;
    t && (this.documentBuilder.openNode(t, {
      canvas: e.canvas,
      text: e.text,
      messenger_app_id: e.messenger_app_id,
      uri: e.uri
    }), this.documentBuilder.closeNode());
  }
  alignmentClass(e) {
    return "align" in e ? e.align : u;
  }
  addFontFamily(e) {
    var t;
    if ("style" in e)
      return (t = e.style) == null ? void 0 : t.fontFamily;
  }
  addFontColor(e) {
    var t;
    if ("style" in e)
      return (t = e.style) == null ? void 0 : t.fontColor;
  }
  // TODO: interblocks.ts should export Stylable type
  addBackgroundColor(e) {
    var t;
    if ("style" in e)
      return (t = e.style) == null ? void 0 : t.backgroundColor;
  }
  addBorderColor(e) {
    var t;
    if ("style" in e)
      return (t = e.style) == null ? void 0 : t.borderColor;
  }
  addBorderStyle(e) {
    var t;
    if ("style" in e)
      return (t = e.style) == null ? void 0 : t.borderStyle;
  }
  addBorderWidth(e) {
    var t;
    if ("style" in e)
      return (t = e.style) == null ? void 0 : t.borderWidth;
  }
  getPaddingAttrs(e) {
    var t, s, d, o;
    return "style" in e ? {
      paddingTop: ((t = e.style) == null ? void 0 : t.paddingTop) ?? "",
      paddingBottom: ((s = e.style) == null ? void 0 : s.paddingBottom) ?? "",
      paddingLeft: ((d = e.style) == null ? void 0 : d.paddingLeft) ?? "",
      paddingRight: ((o = e.style) == null ? void 0 : o.paddingRight) ?? ""
    } : {};
  }
  addBorderRadius(e) {
    var t;
    if ("style" in e)
      return (t = e.style) == null ? void 0 : t.borderRadius;
  }
}
export {
  C as BlockParser
};
